import { render, staticRenderFns } from "./PalletInChamber.vue?vue&type=template&id=f3462c00"
import script from "./PalletInChamber.vue?vue&type=script&lang=js"
export * from "./PalletInChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports